export default __webpack_public_path__ + "static/media/weez-logo.81d3d53c.gif";